module.exports = __webpack_public_path__ + "static/media/usericon.5c383b68.png";